import Viewport from 'common/utils/viewport';
import ScrollToElement from 'marketing/components/ScrollToElement';

export default class CategoriesScrollBehaviour {
    constructor() {
        this.searchBox = document.querySelector('[data-search-field]');
        this.searchButtons = Array.from(document.querySelectorAll('[data-search-button]'));
        this.browsePane =  document.querySelector('[data-browse-pane]');
        this.scrollToSearchBox = this.scrollToSearchBox.bind(this);

        this.addScrollBehaviourToSearchButtons();
        this.addScrollBehaviourToBrowsePane();
        this.addScrollBehaviourToSearchBox();
    }

    addScrollBehaviourToBrowsePane() {
        this.browsePane.addEventListener('click', () => {
            const viewport = new Viewport();

            if (viewport.inSize(['normal', 'large'])) {
                this.scrollToBrowsePane();
            }
        });
    }

    addScrollBehaviourToSearchBox() {
        this.searchBox.addEventListener('keyup', (event) => {
            // if the key pressed is the Enter key
            if (event.keyCode === 13) {
                this.scrollToSearchBox();
            }
        });
    }

    addScrollBehaviourToSearchButtons() {
        this.searchButtons.forEach((searchButton) => {
            searchButton.addEventListener('click', this.scrollToSearchBox);
        });
    }

    scrollToSearchBox() {
        new ScrollToElement(this.searchBox).scroll();
    }

    scrollToBrowsePane() {
        new ScrollToElement(this.browsePane).scrollDownToElement();
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/CategoriesScrollBehaviour.js